import { useEffect } from 'react';
import { AppProps } from 'next/app';
import { version as globalStylesVersion } from '@marriott/global-styles/package.json';

import { addTargetToIFrame, getSessionDataClient, updateTarget } from './helper';
import { usePersistentGlobalStore } from '@marriott/mi-store-utils';

declare global {
  interface Window {
    updateTarget: (arg1: string, arg2: string, arg3: string, arg4: string) => void;
  }
}

export const useSetupSession = ({ pageProps }: AppProps, updateAriaLive: () => void, isAuthorMode = false) => {
  const { isIframeCard, isExpFrag, NEXT_GLOBAL_ASSET_PREFIX } = pageProps;

  const updateGlobalData = usePersistentGlobalStore(
    (state: { updateGlobalData?: (key: string, value: unknown) => void }) => state.updateGlobalData
  );

  useEffect(() => {
    // This code is for loading global css in Remote SPA Authoring Page.
    if (isAuthorMode) {
      let remoteURL: URL | string;
      try {
        remoteURL = new URL(document.body.dataset['remoteUrl'] || '');
        remoteURL = remoteURL.origin;
      } catch (e) {
        remoteURL = '';
      }
      const assetUrl = `${
        process.env['NEXT_PUBLIC_ASSET_DOMAIN'] || remoteURL || 'https://www.marriott.com'
      }${NEXT_GLOBAL_ASSET_PREFIX}`;

      const globalStyle = document.createElement('link');

      globalStyle.rel = 'stylesheet';
      globalStyle.href =
        assetUrl +
        (pageProps?.model?.rtlEnable === 'true'
          ? `global-styles/${globalStylesVersion}/marriot.global.rtl.css`
          : `global-styles/${globalStylesVersion}/marriot.global.css`);
      document.head.appendChild(globalStyle);
    }
    // added to updated the session Data for the global data store
    updateGlobalData?.('sessionData', pageProps?.sessionData);
    const refetchSessionData = sessionStorage.getItem('refetchSession') || 'false';
    async function setSession() {
      if (JSON.parse(refetchSessionData) || isExpFrag) {
        //todo remove this call after testing because we will making call from public folder for the same.
        const { sessionData } = await getSessionDataClient(isExpFrag);
        if (sessionData) {
          const authenticated = sessionData?.authenticated;
          window['sessionDataClient'] = sessionData;
          sessionStorage.setItem('authenticated', JSON.stringify(authenticated));
          sessionStorage.setItem('sessionData', JSON.stringify(sessionData));
          sessionStorage.setItem('refetchSession', JSON.stringify(false));
        }
      }
    }
    !isIframeCard && !isAuthorMode && setSession();
    isIframeCard && updateAriaLive();

    // -----------------Observer logic starts here------------------
    const intervalId = addTargetToIFrame();
    window['updateTarget'] = updateTarget;
    return () => {
      clearTimeout(intervalId);
    };
    // -----------------Observer logic Ends here------------------
  }, []);
};
